import { Component } from 'react';

const images = Array.from(Array(10)).map((_item, index) => {
  return require(`../../assets/images/quiz-pic-${index}.jpeg`).default;
});

export default function withQuizPic(WrapperComponent) {
  return class extends Component {
    constructor() {
      super();
      this.state = {
        images,
      };
    }

    getRandomImage = (count) => {
      return images[count % images.length];
    };

    render() {
      return (
        <WrapperComponent
          {...this.props}
          getRandomImage={this.getRandomImage}
          quizImages={this.state.images}
        />
      );
    }
  };
}
